"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FleetCounters = exports.Counters = exports.ByModelModeStatus = exports.ByModelModeStatusMode = exports.ByModelAndConnection = exports.ConnectionCounters = exports.DeviceCounters = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../date");
const base_1 = require("../class/base");
const Common = __importStar(require("../class/common"));
exports.NAMESPACE = 'Culligan.Device.Report.FleetCounters';
exports.DeviceCounters = effect_1.Schema.Struct({
    totalDevices: effect_1.Schema.NonNegativeInt,
    devicesWithCriticalAlarms: effect_1.Schema.optionalWith(effect_1.Schema.NonNegativeInt, { default: () => 0, exact: true }),
    devicesWithNonCriticalAlarms: effect_1.Schema.optionalWith(effect_1.Schema.NonNegativeInt, { default: () => 0, exact: true }),
    devicesWithoutAlarms: effect_1.Schema.optionalWith(effect_1.Schema.NonNegativeInt, { default: () => 0, exact: true }),
    devicesWithoutTelemetry: effect_1.Schema.NonNegativeInt,
    filterUsageAtOrAbove20: effect_1.Schema.NonNegativeInt,
    filterUsageBelow20: effect_1.Schema.NonNegativeInt,
    filterEmpty: effect_1.Schema.NonNegativeInt,
    co2UsageAtOrAbove20: effect_1.Schema.NonNegativeInt,
    co2UsageBelow20: effect_1.Schema.NonNegativeInt,
    co2Empty: effect_1.Schema.NonNegativeInt,
    enhancementsUsageAtOrAbove20: effect_1.Schema.NonNegativeInt,
    enhancementsUsageBelow20: effect_1.Schema.NonNegativeInt,
    enhancementsEmpty: effect_1.Schema.NonNegativeInt,
    installed: effect_1.Schema.NonNegativeInt,
    inWarehouse: effect_1.Schema.NonNegativeInt,
    inFactory: effect_1.Schema.NonNegativeInt,
    connected: effect_1.Schema.NonNegativeInt,
    disconnected: effect_1.Schema.NonNegativeInt,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceCounters`,
    description: 'Basic device counter metrics',
});
exports.ConnectionCounters = effect_1.Schema.Record({
    key: base_1.ConnectionState,
    value: exports.DeviceCounters,
}).annotations({
    identifier: `${exports.NAMESPACE}.ConnectionCounters`,
    description: 'Counters grouped by connection status',
});
exports.ByModelAndConnection = effect_1.Schema.partialWith(effect_1.Schema.Record({
    key: Common.ModelCode,
    value: exports.ConnectionCounters,
}), { exact: true }).annotations({
    identifier: `${exports.NAMESPACE}.ByModelAndConnection`,
    description: '3D matrix: model - connection status - metrics',
});
exports.ByModelModeStatusMode = effect_1.Schema.Union(base_1.OperatingMode, effect_1.Schema.Literal('Unknown')).annotations({
    identifier: `${exports.NAMESPACE}.ByModelModeStatusMode`,
});
exports.ByModelModeStatus = effect_1.Schema.partialWith(effect_1.Schema.Record({
    key: Common.ModelCode,
    value: effect_1.Schema.partialWith(effect_1.Schema.Record({
        key: exports.ByModelModeStatusMode,
        value: effect_1.Schema.partialWith(effect_1.Schema.Record({
            key: base_1.InstallationStatus,
            value: exports.ConnectionCounters,
        }), { exact: true }),
    }), { exact: true }),
}), { exact: true }).annotations({
    identifier: `${exports.NAMESPACE}.ByModelModeStatus`,
    description: '5D matrix: model - operating mode - installation status - connection status - metrics. ' +
        'Devices with null/missing installationStatus are bucketed as Factory; ' +
        'devices with null/unknown operatingMode are bucketed under Unknown.',
});
exports.Counters = effect_1.Schema.extend(exports.DeviceCounters, effect_1.Schema.Struct({
    byModelAndConnection: exports.ByModelAndConnection,
    installedByModelAndConnection: effect_1.Schema.optionalWith(exports.ByModelAndConnection, { exact: true }),
    byModelModeStatus: effect_1.Schema.optionalWith(exports.ByModelModeStatus, { exact: true }),
})).annotations({
    identifier: `${exports.NAMESPACE}.Counters`,
    description: 'Fleet counters structure',
});
exports.FleetCounters = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.pattern(/^counters_[a-zA-Z0-9_-]+$/))).annotations({
        description: 'Format: counters_{tenantId} or counters_root for all tenants',
    }),
    tenantId: effect_1.Schema.propertySignature(effect_1.Schema.OptionFromNullOr(effect_1.Schema.NonEmptyString)).annotations({
        description: 'Tenant ID, or None for devices without assigned tenant',
    }),
    lastUpdated: date_1.UtcIsoDateString,
    counters: exports.Counters,
}).annotations({
    identifier: `${exports.NAMESPACE}.FleetCounters`,
    description: 'Fleet counters entity for a specific tenant or root aggregation',
});
//# sourceMappingURL=fleetCounters.js.map